import { isEmpty, get } from 'lodash'
import { webRequestClient } from '@/services'
import { errorHandler } from '@/utils/helpers'

const actions = {
    requestDataExport({ commit }, params) {
        const requestParams = { ...params }
        return webRequestClient
            .post('/audience_admin/wam_exports.json', requestParams)
            .then(response => {
                if (!isEmpty(response) && response.status !== 'KO') {
                    commit(
                        'notifications/setAddedNotification',
                        {
                            type: 'success',
                            message: 'This report is successfully planned for sending via email'
                        },
                        { root: true }
                    )
                } else {
                    errorHandler('Failed export', commit)
                }
            })
            .catch(error => {
                const apiErrorStatus = get(error, 'apiError.status', null)
                if (apiErrorStatus === 406) {
                    commit(
                        'notifications/setAddedNotification',
                        {
                            type: 'success',
                            message: 'This report already exists. You will receive it soon.'
                        },
                        { root: true }
                    )
                } else errorHandler(error, commit)
            })
    }
}

export default actions
